import PageFilters from "./PageFilters"; // Import Filters component for managing document filters
import styles from "./Menu.module.scss"; // Import styles for the Menu component
import Threads from "../Threads"; // Import Threads component for displaying chat history
import ErrorBoundary from "./ErrorBoundary";
import PromptsLibrary from "./PromptsLibrary";
import FileSelectorNew from "./FileSelector/FileSelectorNew";
import SummaryViewer from "./SummaryViewer";
import useIsMobile from "../../../hooks/useIsMobile";
import Tasks from "./Tasks";
import React, { useState, useEffect } from "react";


interface MenuProps {
  criterias: any;
  filters: any;
  setFilters: (filters: any) => void;
  page: string;
  selectedMenu: number;
  setSelectedMenu: (selectedMenu: number) => void;
  setMenuVisibility: (visibility: boolean) => void;
  isUpdatingCriterias?: boolean;
  selectedMode: string;
  setSelectedMode: (selectedMode: string) => void;
  promptLibraryData: any[];
  summaryView: {viewed: boolean, doc: string, summary: string};
  setSummaryView: (summaryView: {viewed: boolean, doc: string, summary: string}) => void;
  fileSelectorRef: React.RefObject<any>;
  devMode?: boolean;
}

// Menu component to manage filters and chat history
function Menu({ criterias, filters, setFilters, page, selectedMenu, setSelectedMenu, setMenuVisibility, isUpdatingCriterias = false, selectedMode, setSelectedMode, promptLibraryData, summaryView, setSummaryView, fileSelectorRef, devMode = false }: MenuProps) {
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (page === 'mydeal' && criterias?.subIndustry?.length > 0) {
      setFiltersInitialized(true);
    } else if (page !== 'mydeal') {
      setFiltersInitialized(true);
    }
  }, [page, criterias?.subIndustry]);

  const MENU_TITLE = selectedMenu === 1 ? 
    selectedMode === "MYGEORGES" ? "Chat with my documents" : "Filters & documents" : 
    selectedMenu === 2 ? "History" : 
    selectedMenu === 3 ? "Prompt library" : 
    selectedMenu === 4 ? "Summary" : 
    selectedMenu === 5 ? "My tasks" : "";

  return (
    <div
      className={`${styles.menuContent} d-flex flex-column gap-2 h-100`}
      style={{ width: "100%", paddingLeft: "0px" }}
    >
      <h5 className="mb-0" style={{marginTop: 20, marginLeft: 10}}>
        {MENU_TITLE}
      </h5>

      <div className="d-flex flex-row flex-grow-1 width-full height-100 overflow-hidden custom-sidebar">
        <div className="flex-row flex-grow-1 width-full height-100" style={{ display: selectedMenu === 1 ? "flex" : "none" }}>
          {selectedMode !== "MYGEORGES" && page !== "oreima" ? (
            <>
              <div className="d-flex flex-column flex-grow-1 overflow-y-scroll" style={{width: isMobile ? "100%" : "40%"}}>
                <PageFilters
                  criterias={criterias}
                  filters={filters}
                  setFilters={setFilters}
                  page={page}
                />
              </div>
              <div className="d-flex flex-column flex-grow-1 overflow-y-hidden" style={{width: isMobile ? "0vw" : "60%"}}>
                {filtersInitialized && (
                  <ErrorBoundary>
                    <FileSelectorNew 
                      ref={fileSelectorRef}
                      setFilters={setFilters}
                      setSelectedMenu={setSelectedMenu}
                      filters={filters}
                      page={page}
                      isUpdatingCriterias={isUpdatingCriterias}
                      selectedMode={selectedMode}
                      setSummaryView={setSummaryView}
                    />
                  </ErrorBoundary>
                )}
              </div>
            </>
          ) : (
            <div className="d-flex flex-column flex-grow-1 overflow-y-hidden" style={{width: isMobile ? "100%" : "100%"}}>
              {filtersInitialized && (
                <ErrorBoundary>
                  <FileSelectorNew 
                    ref={fileSelectorRef}
                    setFilters={setFilters}
                    setSelectedMenu={setSelectedMenu}
                    filters={filters}
                    page={page}
                    isUpdatingCriterias={isUpdatingCriterias}
                    selectedMode={selectedMode}
                    setSummaryView={setSummaryView}
                  />
                </ErrorBoundary>
              )}
            </div>
          )}
        </div>
        <div style={{ display: selectedMenu === 2 ? "flex" : "none", width: "100%" }}>
          <Threads setSelectedMenu={setSelectedMenu} setMenuVisibility={setMenuVisibility} />
        </div>
        <div style={{ display: selectedMenu === 3 ? "flex" : "none", width: "100%" }}>
          <PromptsLibrary 
            selectedMode={selectedMode}
            filters={filters}
            page={page}
            promptLibraryData={promptLibraryData}
          />
        </div>
        <div style={{ display: selectedMenu === 4 ? "flex" : "none", width: "100%" }}>
          <SummaryViewer 
            summaryView={summaryView}
            setSummaryView={setSummaryView}
          />
        </div>
        <div style={{ display: selectedMenu === 5 ? "flex" : "none", width: "100%" }}>
          <Tasks
            page={page}
            selectedMode={selectedMode}
            setSelectedMenu={setSelectedMenu}
            setSelectedMode={setSelectedMode}
            setSummaryView={setSummaryView}
            devMode={devMode}
          />
        </div>
      </div>
    </div>
  );
}

export default Menu; // Export Menu component for use in other parts of the application
